import React, {useContext} from 'react';
import {useFormState} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';
import trans from '@src/helpers/trans';
import {LocaleContext} from '@src/contexts/LocaleContext';

export function LabelField({rowIndex: index, config: {label}}: IListColumnProps) {
    const {
        control,
        fieldName,
        forceReadonly,
        forceDisabled,
    } = useContext<IFormFieldItemPropsContext<IClientModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);
    const {locale} = useContext(LocaleContext);
    const {errors} = useFormState<IClientModel>({control});

    if (!control) {
        return null;
    }

    return <>
        <input
                type="text"
                className={classnames('form-control form-control-sm', {
                    'is-invalid': Boolean(errors.contacts?.[index]?.quantity)
                })}
                step={1}
                min={1}
                {...control.register(`${fieldName}.${index}.label`)}
                readOnly={design.fieldsAreReadOnly || forceReadonly}
                disabled={design.fieldsAreDisabled || forceDisabled}
                placeholder={label ? trans(label, locale) : undefined}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.label`}/>
    </>;
}
